<template>
  <v-form ref="form" v-model="valid" lazy-validation class="full">
    <v-col class="md-hidden pager-row">
      <span class="back-button" @click="goBack">
        <i class="fas fa-chevron-left m-r-5"></i>
        Go Back
      </span>
      <radial-progress-bar
        :diameter="45"
        :completed-steps="completedSteps"
        :total-steps="totalSteps"
        :startColor="'#00A8C8'"
        :stopColor="'#00A8C8'"
        :innerStrokeColor="'#B0E5EF'"
        :strokeWidth="3"
        :innerStrokeWidth="3"
        class="right progress-bar"
      >
        <p>
          <span>{{ completedSteps }}</span> of {{ totalSteps }}
        </p>
      </radial-progress-bar>
    </v-col>
    <div class="form-body col-md-8 col col-12">
      <v-col cols="12" sm="12" md="12" class="alert-div-home" :lang="getLang" v-html="$t('lang.pi.alert-msg2')"></v-col>

      <v-col cols="12" sm="12" md="12" class="header-div">
        <h3>Personal Information</h3>
      </v-col>
      <v-row class="form-item-section">
        <v-col cols="12" sm="12" md="6" class="input-wrapper">
          <v-list-item-title>
            Name of yacht owner <span class="red-star">*</span>
            <br />
            <b class="hide">&nbsp;.</b>
          </v-list-item-title>
          <v-text-field
            v-model="personalDetails.name"
            color="primary"
            solo
            outlined
            flat
            dense
            :rules="[rules.required]"
            :validate-on-blur="true"
            maxlength="150"
          />
        </v-col>
        <v-col cols="12" sm="12" md="6" class="input-wrapper" v-if="$store.state.country !== 'th'">
          <v-list-item-title>
            Personal I.D. Card or Certificate of Business Registration of the Yacht Owner(s)
          </v-list-item-title>
          <v-text-field
            v-model="personalDetails.id"
            color="primary"
            solo
            outlined
            flat
            dense
            :validate-on-blur="true"
            maxlength="30"
          />
        </v-col>
        <v-col cols="12" sm="12" md="6" class="input-wrapper">
          <v-list-item-title>
            Yacht owner's nationality <span class="red-star">*</span>
            <span
            class="xs-hidden"
            v-if="$store.state.country === 'th'">
            <br/>
            <b class="hide">&nbsp;.</b>
          </span>
          </v-list-item-title>
          <v-text-field
            v-model="personalDetails.nationality"
            color="primary"
            solo
            outlined
            flat
            dense
            :rules="[rules.required]"
            :validate-on-blur="true"
            maxlength="20"
          />
        </v-col>
      </v-row>

      <v-col cols="12" sm="12" md="12" class="header-div">
        <h3>Contact Information</h3>
      </v-col>

      <v-row class="form-item-section">
        <v-col cols="12" sm="12" md="6" class="input-wrapper">
          <v-list-item-title>
            Contact phone number <span class="red-star">*</span>
          </v-list-item-title>

          <div>
            <v-text-field
              v-model="personalDetails.phone_country_code"
              color="primary"
              solo
              outlined
              flat
              dense
              @keypress="isNumber($event)"
              :rules="[rules.required, rules.numberRule]"
              :validate-on-blur="true"
              maxlength="3"
              style="width: 25%; float: left;"
            />
            <v-text-field
              v-model="personalDetails.phone"
              color="primary"
              solo
              outlined
              flat
              dense
              @keypress="isNumber($event)"
              :rules="[rules.required, rules.numberRule]"
              :validate-on-blur="true"
              maxlength="20"
              style="width: calc(75% - 8px); float: right;"
            />
          </div>
        </v-col>
        <v-col cols="12" sm="12" md="6" class="input-wrapper">
          <v-list-item-title>
            Email <span class="red-star">*</span>
          </v-list-item-title>
          <v-text-field
            v-model="personalDetails.email"
            color="primary"
            solo
            outlined
            flat
            dense
            :rules="[rules.required, rules.emailValidation]"
            :validate-on-blur="true"
            maxlength="50"
          />
        </v-col>
      </v-row>

      <v-col cols="12" sm="12" md="12" class="header-div">
        <h3>Yacht Owner’s Address</h3>
      </v-col>

      <v-col cols="12" sm="12" md="12" class="alert-div-home" :lang="getLang" v-html="$t('lang.pi.alert-msg')"></v-col>

      <v-row class="form-item-section" style="border-radius: 0px 0px 6px 6px">
        <v-col cols="12" sm="12" md="6" class="input-wrapper d-flex">
          <v-list-item-title>
            Country <span class="red-star">*</span>
          </v-list-item-title>
          <v-select
            v-model="personalDetails.country"
            outlined
            dense
            color="primary"
            :items="countryList"
            label="Select Country"
            item-text="value"
            item-value="key"
            :single-line="true"
            :rules="[rules.required]"
          />
        </v-col>
        <v-col cols="12" sm="12" md="6" class="input-wrapper">
          <v-list-item-title>
            Address 1 <span class="red-star">*</span>
          </v-list-item-title>
          <v-text-field
            v-model="personalDetails.address1"
            color="primary"
            solo
            outlined
            flat
            dense
            :rules="[rules.required]"
            :validate-on-blur="true"
            maxlength="30"
          />
        </v-col>
        <v-col cols="12" sm="12" md="6" class="input-wrapper">
          <v-list-item-title>
            Address 2
          </v-list-item-title>
          <v-text-field
            v-model="personalDetails.address2"
            color="primary"
            solo
            outlined
            flat
            dense
            :validate-on-blur="true"
            maxlength="30"
          />
        </v-col>
        <v-col cols="12" sm="12" md="6" class="input-wrapper">
          <v-list-item-title>
            Address 3
          </v-list-item-title>
          <v-text-field
            v-model="personalDetails.address3"
            color="primary"
            solo
            outlined
            flat
            dense
            :validate-on-blur="true"
            maxlength="30"
          />
        </v-col>
        <v-col cols="12" sm="12" md="6" class="input-wrapper">
          <v-list-item-title>
            Address 4
          </v-list-item-title>
          <v-text-field
            v-model="personalDetails.address4"
            color="primary"
            solo
            outlined
            flat
            dense
            :validate-on-blur="true"
            maxlength="30"
          />
        </v-col>
        <v-col cols="12" sm="12" md="6" class="input-wrapper">
          <v-list-item-title>
            Address 5
          </v-list-item-title>
          <v-text-field
            v-model="personalDetails.address5"
            color="primary"
            solo
            outlined
            flat
            dense
            :validate-on-blur="true"
            maxlength="30"
          />
        </v-col>
      </v-row>

      <v-col cols="12" sm="12" md="12" class="header-div">
        <h3>Other Information</h3>
      </v-col>

      <v-row class="form-item-section">
        <v-col cols="12" sm="12" md="6" class="input-wrapper">
          <v-list-item-title ref="textbox">
            Owner's business nature / occupation
          </v-list-item-title>
          <v-text-field
            v-model="personalDetails.business_nature"
            color="primary"
            solo
            outlined
            flat
            dense
            :validate-on-blur="true"
            maxlength="20"
          />
        </v-col>
        <v-col cols="12" sm="12" md="6" class="input-wrapper">
          <v-list-item-title :style="{ height: adjustHeight}">
            Mortgagees (if any)
          </v-list-item-title>
          <v-text-field
            v-model="personalDetails.mortgagees"
            color="primary"
            solo
            outlined
            flat
            dense
            :validate-on-blur="true"
            maxlength="100"
          />
        </v-col>
      </v-row>

      <v-dialog
        v-model="$store.state.showPageDialog"
        persistent
        class="vue-dialog"
      >
        <v-card class="info-dialog">
          <div class="heading">
            Please Note
          </div>
          <div class="body" style="padding-left: 40px;">
            <ul>
              <li style="margin-bottom: 20px">
                You are unable to save or return to a partially completed
                application. Please ensure you have all the necessary
                information ready before proceeding.
              </li>
            </ul>
          </div>
          <div class="footer-section">
            <button class="cancel xs-hidden left" @click="goBack">
              Cancel
            </button>
            <button @click="closeDialog" class="right">
              Continue
            </button>
            <button class="cancel md-hidden" @click="goBack">
              Cancel
            </button>
          </div>
        </v-card>
      </v-dialog>
    </div>
    <v-col
      cols="12"
      class="button-container col-md-8"
      v-if="!$store.state.isEditMode"
    >
      <v-btn
        class="ma-2 form-button cancel"
        outlined
        color="black"
        @click="goBack"
      >
        <span class="back-icon"></span>
        Previous Step
      </v-btn>
      <v-btn
        class="ma-2 form-button continue right"
        dark
        color="#00A8C8"
        @click="validateAndGoNext"
      >
        Continue
        <span class="next-icon"></span>
      </v-btn>
    </v-col>
    <v-col
      cols="12"
      class="button-container col-md-8"
      v-if="$store.state.isEditMode"
    >
      <v-btn
        class="ma-2 form-button cancel"
        outlined
        color="black"
        @click="cancelChange"
      >
        <span class="back-icon"></span>
        Cancel Changes
      </v-btn>
      <v-btn
        class="ma-2 form-button continue right"
        dark
        color="#00A8C8"
        @click="applyChange"
      >
        Apply Changes
        <span class="next-icon"></span>
      </v-btn>
    </v-col>
  </v-form>
</template>

<script>
import PremiumApi from "@/plugins/axios";
import { mapGetters, mapMutations } from "vuex";
import RadialProgressBar from "vue-radial-progress";

export default {
  components: {
    RadialProgressBar,
  },
  data() {
    return {
      rules: {
        required: (value) => !!value || "This field is mandatory",
        numberRule: (value) => {
          const pattern = /^\d+$/;
          if (value == null || value == undefined) {
            return true;
          }
          return (
            pattern.test(
              String(value)
                .replace(/\,/g, "")
                .replace(/\-/g, "")
            ) || "This field must have numeric value"
          );
        },
        _required: (value) => !!value || " ",
        emailValidation: (value) => {
          var pattern = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,10}$/i;
          if (value == null || value === undefined || value === "") {
            return true;
          }
          return pattern.test(value) || "E-mail must be valid";
        },
      },
      location: null,
      valid: false,
      dialog: true,
      completedSteps: 1,
      totalSteps: 7,
      adjustHeight: 'auto',
      personalDetails: this.getpersonalDetails(),
    };
  },
  methods: {
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    validateAndGoNext: function() {
      if (this.$refs.form.validate()) {
        this.$store.commit("savePersonalDetails", this.personalDetails);
        this.$store.state.formPageNumber = 2;
      } else {
        let context = this;
        setTimeout(function() {
          let inavlidField = context.$el.querySelector(".v-messages__message");
          if (inavlidField) {
            context.$vuetify.goTo(
              context.$el.querySelector(".v-messages__message").parentNode
                .parentNode.parentNode.parentNode.parentNode.parentNode,
              { container: document.documentElement, duration: 100 }
            );
            let focusElement = context.$el.querySelector(".v-messages__message")
              .parentNode.parentNode.parentNode.parentNode.parentNode
              .parentNode;
            focusElement.focus();
          }
        }, 100);
      }
    },
    goBack: function() {
      this.$store.state.formPageNumber = 0;
    },
    cancelChange: function() {
      this.$store.state.isEditMode = false;
      this.$store.state.formPageNumber = 7;
    },
    applyChange: function() {
      if (this.$refs.form.validate()) {
        this.$store.commit("savePersonalDetails", this.personalDetails);
        this.$store.state.isEditMode = false;
        this.$store.state.formPageNumber = 7;
      } else {
        let context = this;
        setTimeout(function() {
          let inavlidField = context.$el.querySelector(".v-messages__message");
          if (inavlidField) {
            context.$vuetify.goTo(
              context.$el.querySelector(".v-messages__message").parentNode
                .parentNode.parentNode.parentNode.parentNode.parentNode,
              { container: document.documentElement, duration: 100 }
            );
            let focusElement = context.$el.querySelector(".v-messages__message")
              .parentNode.parentNode.parentNode.parentNode.parentNode
              .parentNode;
            focusElement.focus();
          }
        }, 100);
      }
    },
    closeDialog: function() {
      this.$store.state.showPageDialog = false;
    },
    getpersonalDetails: function() {
      return _.cloneDeep(this.$store.getters.getPersonalDetails);
    },
    trackPage: function() {
      const postData = this.$store.state.accessData;
      postData.url = window.location.href + '/PersonalInformation';
      PremiumApi.logAccess(postData, function(data) {
        console.log('Data sent with : ' + JSON.stringify(postData));
      });
    },
    getHeight: function() {
      if(this.$refs.textbox) {
        this.adjustHeight = this.$refs.textbox.clientHeight + 'px';
      }
    }
  },
  mounted: function() {
    window.scrollTo(0, 0);
    this.trackPage();
    this.getHeight();
    window.addEventListener('resize', this.getHeight);
  },
  beforeDestroy() {
    if (typeof window === "undefined") return;
    window.removeEventListener("resize", this.getHeight, { passive: true });
  },
  computed: {
    ...mapGetters(["countryList"]),
    getLang() {
      //return this.$store.state.country === "hk" ? "hk" : "sg";
      if(this.$store.state.country === "hk"){
        return "hk";
      }else if(this.$store.state.country === "th"){
        return "th";
      }else {
        return "sg";
      }
    },
  },
};
</script>
